module.exports = __webpack_public_path__ + "img/green-icon(2).59fb033e.png";